import { combineReducers } from '@reduxjs/toolkit';
import currentAddressReducer from './CurrentAddress/slice';
import historyReducer from './History/slice';
import housingArrangementsReducer from './HousingArrangements/slice';

export default combineReducers({
  current_address: currentAddressReducer,
  history: historyReducer,
  housing_arrangements: housingArrangementsReducer,
});
